import React from 'react'
import { Separator, Paragraph, MoreLess } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { getMostRecentFieldValue } from '@fs/zion-sls'

// Something about the Paragraph component causes an odd line count, 14 shows 10 facts
const INITIAL_DISPLAY_LINE_COUNT = 14

const AdditionalFactsReviewList = ({ additionalFacts }) => {
  const [t] = useTranslation()

  const factsWithValues = additionalFacts
    .map((fact) => ({
      fact,
      value: getMostRecentFieldValue(fact),
    }))
    .filter(({ value }) => value)

  return (
    <>
      <Separator size="xs" />
      <MoreLess collapsedLineCount={INITIAL_DISPLAY_LINE_COUNT}>
        {factsWithValues.length === 0 && t('additional-facts-card.no-additional-facts', 'No additional facts added.')}
        {factsWithValues.map(({ fact, value }) => (
          <Paragraph size="sm" dense key={fact.id}>
            {`${fact.displayLabel}: ${value}`}
          </Paragraph>
        ))}
      </MoreLess>
    </>
  )
}
export default AdditionalFactsReviewList
